/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Main_MenuInputs */

const en_main_menu = /** @type {(inputs: Main_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Main menu`)
};

const fr_main_menu = /** @type {(inputs: Main_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menu principal`)
};

const de_main_menu = /** @type {(inputs: Main_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hauptmenü`)
};

const it_main_menu = /** @type {(inputs: Main_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menu principale`)
};

const ru_main_menu = /** @type {(inputs: Main_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Главное меню`)
};

const es_main_menu = /** @type {(inputs: Main_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menú principal`)
};

const zh_cn2_main_menu = /** @type {(inputs: Main_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`主菜单`)
};

const ja_main_menu = /** @type {(inputs: Main_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メインメニュー`)
};

const hi_main_menu = /** @type {(inputs: Main_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मुख्य मेन्यू`)
};

const pt_pt2_main_menu = /** @type {(inputs: Main_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menu principal`)
};

/**
* | output |
* | --- |
* | "Main menu" |
*
* @param {Main_MenuInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const main_menu = /** @type {((inputs?: Main_MenuInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Main_MenuInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_main_menu(inputs)
	if (locale === "de") return de_main_menu(inputs)
	if (locale === "it") return it_main_menu(inputs)
	if (locale === "ru") return ru_main_menu(inputs)
	if (locale === "es") return es_main_menu(inputs)
	if (locale === "zh-CN") return zh_cn2_main_menu(inputs)
	if (locale === "ja") return ja_main_menu(inputs)
	if (locale === "hi") return hi_main_menu(inputs)
	if (locale === "pt-PT") return pt_pt2_main_menu(inputs)
	return en_main_menu(inputs)
});